import React from "react";
import { PeekFormControlLabel, PeekCheckbox, useTheme } from "@piiqtechnologies/ui-components";
export const ProviderCheckbox = ({ label, isChecked, onClick, dataTestId, }) => {
    const theme = useTheme();
    return (React.createElement(PeekFormControlLabel, { control: React.createElement(PeekCheckbox, { size: "small", sx: {
                p: 0.5,
                mx: 0.3,
            } }), checked: isChecked, onClick: onClick, label: label, sx: {
            whiteSpace: "nowrap",
            ".MuiCheckbox-root": {
                color: `${theme.palette.grey[400]} !important`,
            },
            ".Mui-checked": {
                color: `${theme.palette.success.main} !important`,
            },
        }, "data-testid": dataTestId }));
};
export default ProviderCheckbox;
